import { useQuery } from "@tanstack/react-query";
import { apiClient, assertJsonArray } from "src/lib/apiClient";
import { keys, staleTimes } from "src/queries/keys";
import { MerchantType } from "src/interfaces/interfaces";

/**
 * Business types open for registration, from GET /merchant/available-types.
 * Only needed when the user is creating something other than a coffee shop, so
 * callers pass `enabled` rather than the hook guessing.
 *
 * Replaces the inline effect in `CreateLocationForm`, which refetched on every
 * mount and gated on `user.loggedIn && user.id !== -1` — the auth-readiness
 * check is now the caller's `enabled` flag.
 */
export const useAvailableTypes = (enabled: boolean) => {
  const { data, isPending, isError } = useQuery({
    queryKey: keys.reference.availableTypes(),
    enabled,
    staleTime: staleTimes.reference,
    queryFn: async () => {
      const response = await apiClient.get("merchant/available-types");
      return assertJsonArray<MerchantType>(
        response.data,
        "/merchant/available-types"
      );
    },
  });

  return {
    merchantTypes: data ?? [],
    loadingTypes: enabled && isPending && !isError,
    typeError: isError ? "Failed to load business types. Please try again." : null,
  };
};
